// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.file-row.odd {
  background: #cce5ff;
}

div.file-row {
  padding: 10px 0;
}
div.file-row button {
  margin-left: 5px;
}

.progress {
  background: none;
  border: 1px #ccc solid;
}

.percentTag {
  text-align: right !important;
  color: black;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/doc-upload/file-upload/file-upload.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,eAAA;AACF;AAAE;EACE,gBAAA;AAEJ;;AAEA;EACE,gBAAA;EACA,sBAAA;AACF;;AACA;EACE,4BAAA;EACA,YAAA;EACA,mBAAA;AAEF","sourcesContent":["div.file-row.odd{\r\n  background: #cce5ff;\r\n}\r\n\r\ndiv.file-row {\r\n  padding: 10px 0;\r\n  button {\r\n    margin-left: 5px;\r\n  }\r\n}\r\n\r\n.progress {\r\n  background: none;\r\n  border: 1px #ccc solid;\r\n}\r\n.percentTag{\r\n  text-align: right !important;\r\n  color: black;\r\n  align-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
